import { render, staticRenderFns } from "./DialogAddress.vue?vue&type=template&id=4eb89502&scoped=true"
import script from "./DialogAddress.vue?vue&type=script&lang=js"
export * from "./DialogAddress.vue?vue&type=script&lang=js"
import style0 from "./DialogAddress.vue?vue&type=style&index=0&id=4eb89502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb89502",
  null
  
)

export default component.exports